export default __webpack_public_path__ + "images/04db0866ff79ffc1a1f1d7ffa80196a0.png";